import React from 'react'
import { IStoreProduct, IStorePremiumProduct, StoreProduct } from 'protos'

import T from 'components/FormattedMessage'
import Currency from 'components/Currency'

interface Props {
  product?: IStoreProduct | IStorePremiumProduct
}

const isStoreProduct = (product?: IStoreProduct | IStorePremiumProduct): product is IStoreProduct => {
  return !!product && Object.getOwnPropertyNames(product).some((key) => {
    return key === 'quantity' || key === 'level'
  })
}

const isStorePremiumProduct = (product?: IStoreProduct | IStorePremiumProduct): product is IStorePremiumProduct => {
  return !!product && Object.getOwnPropertyNames(product).some((key) => {
    return key === 'quration' || key === 'summary'
  })
}

const isAutosubPackage = (product: IStoreProduct) => {
  return product.type === StoreProduct.Type.AUTOSUB
}

const StoreItemName: React.SFC<Props> = ({ product }) => {
  if (isStorePremiumProduct(product)) {
    return (
      <>
        {product.title || ''}
      </>
    )
  }

  if (isStoreProduct(product)) {
    if (isAutosubPackage(product)) {
      return (
        <>
          <span>{product.quantity} </span>
          <T id="store_autosub_item" />
        </>
      )
    }

    return (
      <Currency value={product.quantity} />
    )
  }

  return null
}

export default StoreItemName
